import i18next from 'i18next'
import z from 'zod'

export const updateProductsByFieldsSchema = z.object({
	skus: z.array(z.string()).max(50, {
		error: () =>
			i18next.t('validation.max_skus', {
				defaultValue: 'Max 50 SKUs',
			}),
	}),
	fields: z
		.array(
			z.object({
				value: z.string().min(1, {
					error: () =>
						i18next.t('validation.required_filed', {
							defaultValue: 'Field is required',
						}),
				}),
				type: z.string().optional(),
				inputValue: z.string().or(z.boolean()),
			})
		)
		.min(1, {
			error: () =>
				i18next.t('bulk_modal_fields_not_added', {
					defaultValue: 'No fields to update selected',
				}),
		}),
})
